import { Component, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { SelectItem } from 'primeng/api';
import { Observable, of, ReplaySubject } from 'rxjs';
import { BudgetWorksheet, WorksheetLine } from '../../data-services/rate-planning';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'ef-rate-planning-presenter',
    templateUrl: './rate-planning-presenter.component.html',
    styleUrls: ['./rate-planning-presenter.component.scss'],
    standalone: false
})
export class RatePlanningPresenterComponent implements OnInit {
    IsColumnFrozen = false;
    dynamicColumns: any[] = [];
    dynamicBWColumns: any[] = [];
    dynamicRatesColumns: any[] = [];
    private RatePlanningSubject = new ReplaySubject<Array<BudgetWorksheet>>(1);
    private _rateplanning: Array<BudgetWorksheet>;
    @Input() set ratePlanning(value: Array<BudgetWorksheet>) {
        if (value && value.length > 0) {
            this._rateplanning = value;
            this.RatePlanningSubject.next(value);

            this.budgetWorksheetData = value.filter(
                x => x.CostTypeGroup == 'ELM'
            );
            if (this.budgetWorksheetData.length > 0) {
                this.dynamicBWColumns = [
                    ...this.getDynamicBWColumns(this.budgetWorksheetData)
                ];
            }

            this.ratesData = value.filter(
                x =>
                    x.CostTypeGroup == 'Rate' ||
                    x.CostTypeGroup == 'Pool' ||
                    x.CostTypeGroup == 'Base'
            );
            if (this.ratesData.length > 0) {
                this.dynamicRatesColumns = [
                    ...this.getDynamicRatesColumns(this.ratesData)
                ];
                this.ratesData = this.ratesData.sort((a, b) => {
                    if (a.CCDesc === b.CCDesc) {
                        return a.CostType.localeCompare(b.CostType);
                    }
                    return a.CCDesc.localeCompare(b.CCDesc);
                });
            } else {
                this.disableLoading();
            }

            this.multipleCC = !this.isSameProp(value, 'CCDesc');


            const set_ccdesc = new Set(
                this.budgetWorksheetData.map(item => item.CCDesc)
            );
            const unique_ccdesc = [...set_ccdesc];

            const set_ct = new Set(
                this.budgetWorksheetData.map(item => item.CostType)
            );
            const unique_ct = [...set_ct];

            this.costTypesSelectItem = unique_ct.map(x => ({
                label: x.toString(),
                value: x.toString()
            }));

            this.costCentersSelectItem = unique_ccdesc.map(x => ({
                label: x.toString(),
                value: x.toString()
            }));

            const set_ratesccdesc = new Set(
                this.ratesData.map(item => item.CCDesc)
            );
            const unique_ratesccdesc = [...set_ratesccdesc];

            const set_ratesct = new Set(
                this.ratesData.map(item => item.CostType)
            );
            const unique_ratesct = [...set_ratesct];

            this.ratesCostTypesSelectItem = unique_ratesct.map(x => ({
                label: x.toString(),
                value: x.toString()
            }));

            this.ratesCostCentersSelectItem = unique_ratesccdesc.map(x => ({
                label: x.toString(),
                value: x.toString()
            }));

            //this.multipleCC = !this.isSameProp(value, 'CCDesc');

            this.budgetYearEnd = moment(
                this._rateplanning[0].BudgetYearEnd
            ).format('MM/DD/YYYY');

            this.isUpdate = false;

            //this.setupForBudgetWorksheet();
            //this.setupForRates();

            //this.isFirstLoad = false;
            this.IsColumnFrozen = true;
            this.scheduleBudgetCellFocusRestore();
        }
    }

    get ratePlanning(): Array<BudgetWorksheet> {
        return this._rateplanning;
    }

    private FYESubject = new ReplaySubject<Array<SelectItem>>(1);
    private _fye: Array<SelectItem>;
    @Input() set fyeSelectItem(value: Array<SelectItem>) {
        if (value && value.length > 0) {
            value = value.sort((a, b) => new Date(b.value).getTime() - new Date(a.value).getTime());
            this._fye = value;
            this.FYESubject.next(value);

            this.selectedFYE = value.find(x => moment(x.value).year() == moment(new Date()).year()).value;
        }
    }
    get fyeSelectItem(): Array<SelectItem> {
        return this._fye;
    }

    //top table
    budgetWorksheetData: BudgetWorksheet[];
    //bottom table
    ratesData: BudgetWorksheet[];

    showBudgetColumn: boolean;
    showForecastColumn: boolean;

    budgetYearEnd: string;

    @Output() LoadCalcRates = new ReplaySubject<any>(1);
    @Output() LoadRatePlanning = new ReplaySubject<any>(1);
    @Output() UpdateRatePlanning = new ReplaySubject<any>(1);

    multipleCC: boolean;

    ratesCostCentersSelectItem: SelectItem[] = [];
    selectedRatesCCDescFilterValue: any;
    ratesCostTypesSelectItem: SelectItem[] = [];
    selectedRatesCostTypeFilterValue: any;

    costCentersSelectItem: SelectItem[] = [];
    selectedCCDescFilterValue: any;
    costTypesSelectItem: SelectItem[] = [];
    selectedCostTypeFilterValue: any;

    columnDisplaySelectItem: SelectItem[];
    selectedColumnDisplay: any;

    selectedFYE: any;

    loading = false;

    isCalcRates = true;
    isUpdate = false;

    active = true;

    private readonly cellSnapshots = new Map<string, string>();
    private pendingFocusCellKey: string | null = null;

    constructor() {
        this.enableLoading();
    }

    ngOnInit(): void {
        // this.table = document.createElement('table');
        // this.table.setAttribute('id', 'rateplanningtable');

        // this.ratetable = document.createElement('table');
        // this.table.setAttribute('id', 'ratestable');

        // this.selectedColumnDisplay = 1;
        // this.showBudgetColumn = true;
        // this.showForecastColumn = false;
        // this.colspan = 1;

        // this.columnDisplaySelectItem = [
        //     {
        //         label: 'Budget & Forecast',
        //         value: 0
        //     },
        //     {
        //         label: 'Budget',
        //         value: 1
        //     },
        //     {
        //         label: 'Forecast',
        //         value: 2
        //     }
        // ];
    }

    ngOnDestroy() {
        this.active = false;
    }

    private cellKey(row: BudgetWorksheet, lineIndex: number): string {
        return `${row.CCID}|${row.CostType}|${row.Line[lineIndex].Month}`;
    }

    getBudgetCellKey(row: BudgetWorksheet, lineIndex: number): string {
        return this.cellKey(row, lineIndex);
    }

    trackBudgetWorksheetRow(_index: number, row: BudgetWorksheet): string {
        return `${row.CCID}|${row.CostType}`;
    }

    trackBudgetWorksheetLine(_index: number, line: WorksheetLine): string {
        return line.Month;
    }

    onBudgetCellFocus(row: BudgetWorksheet, lineIndex: number): void {
        const line = row.Line[lineIndex];
        this.cellSnapshots.set(
            this.cellKey(row, lineIndex),
            String(line.Budget ?? '')
        );
    }

    onBudgetCellBlur(event: FocusEvent, row: BudgetWorksheet, lineIndex: number): void {
        const related = event.relatedTarget;
        if (related instanceof HTMLInputElement && related.dataset['budgetCell']) {
            this.pendingFocusCellKey = related.dataset['budgetCell'];
        } else {
            this.pendingFocusCellKey = null;
        }

        // Let Tab/click focus the next cell before save triggers a table refresh.
        setTimeout(() => this.commitBudgetCell(row, lineIndex), 0);
    }

    commitBudgetCell(row: BudgetWorksheet, lineIndex: number): void {
        const key = this.cellKey(row, lineIndex);
        const previous = this.cellSnapshots.get(key) ?? '';
        const current = String(row.Line[lineIndex].Budget ?? '').trim();

        if (current === previous) {
            return;
        }

        this.updateRatePlanningTable(row, lineIndex);
        this.cellSnapshots.set(key, current);
    }

    onBudgetCellEnter(event: KeyboardEvent, row: BudgetWorksheet, lineIndex: number): void {
        event.preventDefault();
        this.commitBudgetCell(row, lineIndex);
    }

    private scheduleBudgetCellFocusRestore(): void {
        if (!this.pendingFocusCellKey) {
            return;
        }

        setTimeout(() => this.restoreBudgetCellFocus(), 0);
    }

    private restoreBudgetCellFocus(): void {
        const key = this.pendingFocusCellKey;
        if (!key) {
            return;
        }

        const escapedKey =
            typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
                ? CSS.escape(key)
                : key.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        const input = document.querySelector(
            `input[data-budget-cell="${escapedKey}"]`
        ) as HTMLInputElement | null;

        if (input) {
            input.focus();
            input.select();
            this.pendingFocusCellKey = null;
        }
    }

    isSameProp(array: any[], prop: string): boolean {
        if (array.length === 0) return true;
        const firstValue = array[0][prop];
        return array.every(item => item[prop] === firstValue);
    }

    getDynamicBWColumns(data: any[]): any[] {
        const monthsMap = new Map<string, { month: string; index: number }>();
        let index = 0;

        data.forEach(item => {
            if (item.Line && Array.isArray(item.Line)) {
                item.Line.forEach(line => {
                    if (line && line.Month) {
                        index++;
                        if (!monthsMap.has(line.Month)) {
                            monthsMap.set(line.Month, {
                                month: line.Month,
                                index: index
                            });
                        }
                    }
                });
            }
        });

        return Array.from(monthsMap.values()).map(month => ({
            field: month.month, // Use the month as the field
            header: month.month, // Use the month as the header
            index: month.index
        }));
    }
    getDynamicRatesColumns(data: any[]): any[] {
        const monthsMap = new Map<string, { month: string; index: number }>();
        let index = 0;

        data.forEach(item => {
            if (item.Line && Array.isArray(item.Line)) {
                item.Line.forEach(line => {
                    if (line && line.Month) {
                        index++;
                        if (!monthsMap.has(line.Month)) {
                            monthsMap.set(line.Month, {
                                month: line.Month,
                                index: index
                            });
                        }
                    }
                });
            }
        });
        this.disableLoading();
        return Array.from(monthsMap.values()).map(month => ({
            field: month.month, // Use the month as the field
            header: month.month, // Use the month as the header
            index: month.index
        }));

    }

    updateRatePlanningTable(data, index) {
        const cell = {
            CCID: data.CCID,
            BudgetYearEnd: data.BudgetYearEnd,
            CostType: data.CostType,
            Month: data.Line[index].Month,
            Budget: data.Line[index].Budget,
            Forecast: data.Line[index].Forecast
        };
        this.UpdateRatePlanning.next(cell);
    }

    fyeChanged($event) {
        this.enableLoading();
        this.isCalcRates = true;
        this.LoadRatePlanning.next({ BudgetEnd: $event.value, CalcRates: 1 });
    }

    calcRates() {
        this.enableLoading();
        this.isCalcRates = true;
        this.LoadCalcRates.next({
            BudgetEnd: this.selectedFYE,
            CalcRates: 1
        });
    }

    enableLoading() {
        this.loading = true;
    }

    disableLoading() {
        this.loading = false;
    }

    public get logoPath(): string {
        return 'images/eflogotransparent-avalon-dark.png'; //'images/eflogotransparent-avalon.png';
    }
}
